// extracted by mini-css-extract-plugin
module.exports = {"forecastGraphWindContainer":"ForecastGraphWind_forecastGraphWindContainer__3mWOr","legendContainer":"ForecastGraphWind_legendContainer__ZSTho"};